import { storeWrapper } from '../storeWrapper'

const initialState = {
  isLoading: false
}

// This store tracks a global variable isLoading, which can be used to indicate in the UI that something is happening

export const useLoadingStore = storeWrapper('useLoadingStore', (set) => ({
  ...initialState,
  setIsLoading: (bool) => set({ isLoading: bool }),
  reset: () => set(initialState)
}))
